import { useMemo } from 'react';
import { OptionType } from 'components/CustomSelect/types';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';

const useCompanyListOptions = () => {

  const { companyList } = useWaterfallContext()

  const options = useMemo<OptionType[]>(() => {
    if (!companyList) {
      return []
    }
    return companyList.map(company => ({
      label: company.company_name ?? '',
      value: company.company_id?.toString() ?? '',
    }))
  }, [companyList]);

  return {options}

}

export default useCompanyListOptions;